import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import DialogActions      from '@material-ui/core/DialogActions'
import DialogContent      from '@material-ui/core/DialogContent'
import DialogTitle        from '@material-ui/core/DialogTitle'
import Grid               from '@material-ui/core/Grid'
import { withFormik }     from 'formik'
import { object, string } from 'yup'

import { ActionButton, EnhancedTextField } from '../atoms'
import {
  genValueMapper,
  i18nErrorCodes,
  mapFormikToMuiProps,
  proxyFormikSubmission,
}                                          from './form-utils'

const SessionUpdateFormDialog = withFormik<any, any>({
  mapPropsToValues: genValueMapper({ date: '' }),
  validationSchema: object().shape({ date: string().required(i18nErrorCodes.required) }),
  handleSubmit:     proxyFormikSubmission,
})(
  props => {
    const phrasing = {
      updateSessionPrompt: <FormattedMessage id={'generic.updateSessionPrompt'} />,
    }

    const mapper = mapFormikToMuiProps(props)

    const { handleSubmit } = props

    return (
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          {phrasing.updateSessionPrompt}
        </DialogTitle>

        <DialogContent>
          <Grid
            container
            direction={'column'}
            spacing={16}
          >
            <Grid item>
              <EnhancedTextField
                fullWidth
                type={'datetime-local'}
                InputLabelProps={{ shrink: true }}
                {...mapper('date')}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <ActionButton
            type={'submit'}
            color={'primary'}
            variant={'raised'}
            actionType={'edit'}
          />
        </DialogActions>
      </form>
    )
  },
)

export default SessionUpdateFormDialog



// WEBPACK FOOTER //
// ./src/components/forms/SessionUpdateFormDialog.tsx